import axios from "axios";

//IMPORT API ROUTE URL
import { REMOVE_RECOMMENDATION_HISTORY_CLIENT_ROUTE } from "./apiRoutes";

const removeRecommendationClient = (user_slug, recommendation_id, remark) => {
  var postData = new FormData();

  postData.append("u_id", user_slug);
  postData.append("recommendation_id", recommendation_id);
  postData.append("remove_remark", remark);

  return axios
    .post(REMOVE_RECOMMENDATION_HISTORY_CLIENT_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default removeRecommendationClient;
